import axios from "axios";
// Removed jwt_decode and token storage dependency

const getDefaultUser = () => ({
  email: null,
  id: null,
});
const getDefaultState = () => ({
  user: getDefaultUser(),
  exp: 0,
  expires: 0,
  loading: false,
  initialized: false, // new flag: have we attempted to load session
});

const state = getDefaultState();
const getters = {
  isAuthenticated: (state) => !!state.user.email, // email presence indicates authenticated
  userEmail: (state) => state.user.email,
  sessionExpiresAt: (state) => state.expires || state.exp,
  sessionInitialized: (state) => state.initialized,
};
const mutations = {
  SET_USER(state, user) {
    state.user = { ...state.user, ...user };
  },
  SET_PROP(state, { prop, value }) {
    state[prop] = value;
  },
  RESET_USER(state) {
    state.user = getDefaultUser();
    state.exp = 0;
    state.expires = 0;
  },
  SET_LOADING(state, val) {
    state.loading = val;
  },
  SET_INITIALIZED(state, val) {
    state.initialized = val;
  },
};
const actions = {
  async loadSessionFromCookies({ commit }) {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_AUTH_URL}/token/parse`,
        { withCredentials: true }
      );
      if (!data) return;
      const payload = data.result || data; // support both shapes
      const email = payload.email;
      if (email) {
        commit("SET_USER", { email, id: payload.userId });
      }
      if (payload.expires) {
        commit("SET_PROP", { prop: "expires", value: payload.expires });
      }
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.debug("Session parse failed", e?.message);
      }
    } finally {
      commit("SET_INITIALIZED", true);
    }
  },

  async ensureSession({ getters, dispatch, commit }) {
    if (getters.sessionInitialized) return; // already attempted
    await dispatch("loadSessionFromCookies");
  },

  async logout({ commit }) {
    const base = (process.env.VUE_APP_AUTH_URL || "").replace(/\/$/, "");
    const tokenRemoveUrl = base.endsWith("/api")
      ? `${base}/token/remove`
      : `${base}/api/token/remove`;

    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.debug("Logout: calling", tokenRemoveUrl);
    }

    const serverCall = axios
      .delete(tokenRemoveUrl, { withCredentials: true })
      .catch((err) => {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.debug("Logout server call failed", err?.message);
        }
      });

    const cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;
    const possibleCookieNames = [
      process.env.VUE_APP_ACCESS_TOKEN_COOKIE_NAME,
      process.env.VUE_APP_REFRESH_TOKEN_COOKIE_NAME,
      process.env.VUE_APP_FGP_COOKIE_NAME,
      "token",
      "token_fgp",
      "token_plus",
      process.env.VUE_APP_REDIRECT_COOKIE_NAME,
    ].filter(Boolean);
    const expireCookie = (name) => {
      const baseAttrs = `=${""}; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      document.cookie = `${name}${baseAttrs}`;
      if (cookieDomain) {
        document.cookie = `${name}${baseAttrs}; domain=${cookieDomain}`;
      }
    };
    possibleCookieNames.forEach(expireCookie);

    return serverCall.finally(() => {
      commit("RESET_USER");
      commit(
        "SET_NOTIFICATION_PROPS",
        { messages: ["Logged out"], title: "Info", style: "info", show: true },
        { root: true }
      );
    });
  },
};

export default { namespaced: true, state, getters, actions, mutations };
